import teamGoalsAllTeams from 'images/characters/teamGoals-allTeams.svg';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';

const TeamGoalsAllTeams = () => {
  return (
    <Flex
      items='center'
      justify='center'
      direction='column'
      width='100%'
      pt='x-x-large'
    >
      <img
        src={teamGoalsAllTeams}
        alt=''
        style={{ width: '30rem', height: '22rem' }}
      />
      <Text size='x-x-large' mb='0.5rem' color='shuttleGray'>
        Team Goals is a single team dashboard.
      </Text>
      <Text size='medium' color='shuttleGray'>
        Select a team from the drop-down selector above
      </Text>
    </Flex>
  );
};

export default TeamGoalsAllTeams;
